import { render } from "./ClientsTableLoading.vue?vue&type=template&id=7b9e73ec"
import script from "./ClientsTableLoading.vue?vue&type=script&lang=js"
export * from "./ClientsTableLoading.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__